const isProductWithdrawn = (product) => {
  return (
    product?.doc_status?.toLowerCase() === 'withdrawn' &&
    product?.offer_inactive
  );
};

export default isProductWithdrawn;
